module.exports = __webpack_public_path__ + "img/activeGeolocation.acd51e5d.png";